import React from 'react';
import {
  Box,
  Breadcrumbs,
  Link,
  Stack,
  Typography,
} from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Link as RouterLink } from 'react-router-dom';

const WorkspacePageHeader = ({
  title,
  description,
  eyebrow,
  breadcrumbs = [],
  badges,
  actions,
  sticky = false,
  headingLevel = 'h1',
}) => (
  <Box
    component="header"
    sx={{
      position: sticky ? 'sticky' : 'relative',
      top: sticky ? { xs: 56, md: 0 } : undefined,
      zIndex: sticky ? 8 : undefined,
      py: sticky ? 1.25 : 0,
      px: sticky ? 0.25 : 0,
      bgcolor: sticky ? 'rgba(247, 249, 248, 0.94)' : 'transparent',
      backdropFilter: sticky ? 'blur(12px)' : undefined,
      borderBottom: sticky ? 1 : 0,
      borderColor: 'divider',
    }}
  >
    <Stack direction={{ xs: 'column', md: 'row' }} justifyContent="space-between" spacing={2} alignItems={{ md: 'center' }}>
      <Box sx={{ minWidth: 0 }}>
        {breadcrumbs.length ? (
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="Breadcrumb"
            sx={{ mb: 0.5 }}
          >
            {breadcrumbs.map((crumb, index) => {
              const current = index === breadcrumbs.length - 1 || !crumb.to;
              return current ? (
                <Typography key={`${crumb.label}-${index}`} variant="caption" color="text.secondary" aria-current={index === breadcrumbs.length - 1 ? 'page' : undefined}>
                  {crumb.label}
                </Typography>
              ) : (
                <Link key={`${crumb.label}-${index}`} component={RouterLink} to={crumb.to} variant="caption" underline="hover" color="inherit">
                  {crumb.label}
                </Link>
              );
            })}
          </Breadcrumbs>
        ) : null}
        {eyebrow ? <Typography variant="overline" color="text.secondary">{eyebrow}</Typography> : null}
        <Typography component={headingLevel} variant="h4" sx={{ overflowWrap: 'anywhere' }}>{title}</Typography>
        {description ? <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, maxWidth: 840 }}>{description}</Typography> : null}
        {badges ? <Stack direction="row" spacing={0.75} useFlexGap flexWrap="wrap" sx={{ mt: 1 }}>{badges}</Stack> : null}
      </Box>
      {actions ? (
        <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" justifyContent={{ xs: 'flex-start', md: 'flex-end' }} sx={{ flexShrink: 0 }}>
          {actions}
        </Stack>
      ) : null}
    </Stack>
  </Box>
);

export default WorkspacePageHeader;
